/**
 * Lógica pura del modal "Iniciar validación de secuencia" cuando se inicia en varios vehículos o en todos (VEC-3474), separada del componente para
 * poder probarla sin renderizar.
 */

/** Tope de vehículos por pedido: el mismo que impone la API (FormularioSecuenciaIntentoService::MAX_LOTE). */
export const MAX_LOTE = 2000;

export const MODO_ELEGIR = 'elegir';
export const MODO_TODOS = 'todos';

/** Cuerpo del POST iniciar-lote: `todos: true`, o la lista de ids elegidos. */
export const construirCuerpoLote = (modo, seleccionados) => {
	if (modo === MODO_TODOS) {
		return { todos: true };
	}
	return { movil_ids: (seleccionados || []).map((m) => m.id) };
};

/** Cuántos vehículos va a iniciar el pedido: los elegidos, o los disponibles hasta el tope. */
export const cantidadAIniciar = (modo, seleccionados, disponibles) => {
	if (modo === MODO_TODOS) {
		return Math.min(disponibles || 0, MAX_LOTE);
	}
	return (seleccionados || []).length;
};

/** Cuántos disponibles quedarían sin iniciar por el tope (solo con "todos"): hay que repetir la operación. */
export const quedanSinIniciar = (modo, disponibles) => {
	if (modo !== MODO_TODOS) {
		return 0;
	}
	return Math.max(0, (disponibles || 0) - MAX_LOTE);
};

/** ¿Se puede apretar "Iniciar"? Hace falta una secuencia, al menos un vehículo a iniciar, y que no haya un pedido en curso. */
export const puedeIniciar = (secuencia, modo, seleccionados, disponibles, cargando) => {
	return !!secuencia && !cargando && cantidadAIniciar(modo, seleccionados, disponibles) > 0 && cantidadAIniciar(modo, seleccionados, disponibles) <= MAX_LOTE;
};

/** Motivo (código que devuelve la API) y los datos con los que se arma el texto para mostrar. */
export const MOTIVOS_DE_OMISION = ['estado_cambio', 'intento_en_curso', 'en_otra_secuencia', 'intentos_agotados', 'sin_acceso', 'otro'];

/** Resumen del resultado: cuántos se iniciaron, cuántos se omitieron y cuántos quedaron por el tope. */
export const resumirResultado = (resultado) => {
	const r = resultado || {};
	return {
		iniciados: (r.iniciados || []).length,
		omitidos: (r.omitidos || []).length,
		restantes: r.restantes || 0,
	};
};
